const initialState = {
    isDemoMode: false
  };
  
  const demoModeReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'TOGGLE_DEMO_MODE':
        return {
          ...state,
          isDemoMode: action.payload
        };
      default:
        return state;
    }
  };
  
  export default demoModeReducer;
  